/**
 * @name SessionService
 * @description Servicio para los accesos de usuario
 * @author Gabriela Urenda
 */

import { AuthService } from './auth.service';

/**
 * Consulta los permisos que tiene un usuario
 * @param {*} id 
 */
/* const getPermissions = (id = null) => {
    const userInfo = JSON.parse(localStorage.getItem('ls.infoUsuario')) || {};
    const permissions = userInfo.Permiso;

    return id !== null ?
}*/

/**
 * Verifica si el usuario tiene los permisos
 * @param {[number]} ids Arreglo de Id's
 */
const hasPermissions = (ids) => {
  const userInfo = JSON.parse(localStorage.getItem('ls.infoUsuario')) || {};
  const permissions = userInfo.Permiso;
  if (!Array.isArray(permissions)) return false;
  return permissions.filter((permission) => ids.indexOf(permission.Id) > -1).length > 0;
};

/**
 * Consulta los roles que tiene un usuario
 * @param {*} id
 */
/* const getRoles = (id = null) => {
    console.log('getRoles');
    const userInfo = JSON.parse(localStorage.getItem('ls.infoUsuario')) || {};
    const roles = userInfo.Rol;
}*/

/** 
 * Verifica si el usuario tiene los roles
 * @param {[number]} ids Arreglo de Id's
 */
const hasRoles = (ids) => {
  const userInfo = JSON.parse(localStorage.getItem('ls.infoUsuario')) || {};
  const roles = userInfo.Rol;
  if (!Array.isArray(roles)) return false;
  return roles.filter((rol) => ids.indexOf(rol.IdRol) > -1).length > 0;
};

/**
 * Verifica si el usuario tiene una aplicación
 * @param {[number]} ids Arreglo de Id's
 */
const hasApplications = (ids) => {
  const userInfo = JSON.parse(localStorage.getItem('ls.infoUsuario')) || {};
  const applications = userInfo.Aplicacion;
  if (!Array.isArray(applications)) return false;
  return applications.filter((app) => ids.indexOf(app.IdAplicacion) > -1).length > 0;
};

// Sincronizar logout entre pestañas
window.addEventListener('storage', (event) => {
  if (event.key === 'ls.authorizationData' && event.oldValue && !event.newValue) {
    // Token eliminado, forzar logout
    AuthService.redirectToLogin();
  }
});

export const SessionService = {
  hasPermissions,
  hasRoles,
  hasApplications
};
